import * as React from 'react';
import Helmet from 'react-helmet';

interface Props {
	id: number;
}

const SbesAds: React.FC<Props> = ({ id }) => {
	React.useEffect(() => {
		const script = document.createElement('script');
		const noscript = document.createElement('noscript');

		script.innerHTML = `
            (function (w, d, c) {
                (w[c] = w[c] || []).push(function() {
                    var options = {
                        project: ${id},
                        trackHashes: true,
                        user_id: null,
                        ecommerce: "dataLayer"
                    };
                    try {
                        w.top100Counter = new top100(options);
                    } catch(e) { }
                });
                var n = d.getElementsByTagName("script")[0],
                s = d.createElement("script"),
                f = function () { n.parentNode.insertBefore(s, n); };
                s.type = "text/javascript";
                s.async = true;
                s.src =
                (d.location.protocol == "https:" ? "https:" : "http:") +
                "//st.top100.ru/top100/top100.js";

                if (w.opera == "[object Opera]") {
                d.addEventListener("DOMContentLoaded", f, false);
            } else { f(); }
            })(window, document, "_top100q");
        `;

		noscript.innerHTML = `<img src="//counter.rambler.ru/top100.cnt?pid=${id}" alt="Топ-100" />`;

		if (document.head && id) {
			document.head.appendChild(script);
			document.head.appendChild(noscript);
		}

		return () => {
			try {
				if (script?.parentNode) {
					script.parentNode.removeChild(script);
				}
				if (noscript?.parentNode) {
					noscript.parentNode.removeChild(noscript);
				}
			} catch (error) {
				console.error('Error removing Top100 scripts:', error);
			}
		};
	}, [id]);

	return <Helmet />;
};

export default SbesAds;
